import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import KimChatbot from "@/components/KimChatbot";
import CookieBanner from "@/components/CookieBanner";

import Home from "@/pages/Home";
import EcolePage from "@/pages/EcolePage";
import PresidentPage from "@/pages/PresidentPage";
import NosValeursPage from "@/pages/NosValeursPage";
import FormationsPage from "@/pages/FormationsPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import PourquoiNousPage from "@/pages/PourquoiNousPage";
import AdmissionsPage from "@/pages/AdmissionsPage";
import ContactPage from "@/pages/ContactPage";
import PartenairesPage from "@/pages/PartenairesPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";
import NotFoundPage from "@/pages/NotFoundPage";

function PublicLayout({ children }) {
  return (
    <div className="bg-white">
      <Header />
      <main data-testid="site-main">{children}</main>
      <Footer />
      <KimChatbot />
      <CookieBanner />
    </div>
  );
}

function RouterShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
      </Routes>
    );
  }
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ecole" element={<EcolePage />} />
        <Route path="/ecole/mot-du-president" element={<PresidentPage />} />
        <Route path="/ecole/nos-valeurs" element={<NosValeursPage />} />
        <Route path="/formations" element={<FormationsPage />} />
        <Route path="/formations/:segment1" element={<ProgramDetailPage />} />
        <Route path="/formations/:segment1/:segment2" element={<ProgramDetailPage />} />
        <Route path="/pourquoi-nous" element={<PourquoiNousPage />} />
        <Route path="/admissions" element={<AdmissionsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/partenaires" element={<PartenairesPage />} />
{/* Route entreprises masquée */}
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{
          className: "rounded-none",
          style: { borderRadius: 0, fontFamily: "Montserrat, sans-serif" },
        }}
      />
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <RouterShell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
